<script setup lang="ts">
interface Props {
  block?: boolean
  color?: string
  disabled?: boolean
  elevation?: number | string
  exact?: boolean
  loading?: boolean | string
  rounded?: boolean | number | string
  size?: number | string
  text?: string
  to?: any
  variant?: string
}

defineProps<Props>()
</script>

<template>
  <v-btn
    :block="block"
    :color="color"
    :disabled="disabled"
    :elevation="elevation"
    :exact="exact"
    :loading="loading"
    :variant="variant"
    :rounded="rounded"
    :size="size"
    :text="text"
    :to="to"
  >
    <slot />
  </v-btn>
</template>
